export const prefix = "bat"
export const iconName = "sort-up"
export const width = 7
export const height = 11
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M0.128693 3.70754L2.91117 0.240371C3.15882 -0.0801236 3.56672 -0.0801236 3.81438 0.240371L6.59685 3.70754C6.84451 4.02803 6.72796 4.29026 6.30549 4.29026H0.420052C-0.00241824 4.29026 -0.118962 4.02803 0.128693 3.70754Z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batSortUp = definition
